import { api } from '..';
import { apiPaths } from '@/services/api/paths';
import type {
  ManualQueueActionDto,
  ManualQueueItemDto,
  ManualQueueListResponse,
  ManualQueueName,
  ManualQueueItemResponse,
} from '@/types/generated/schemas';

export const manualQueueKeys = [
  'security_conflicts',
  'sanitizations',
  'block_reasons',
  'invitation_claims',
  'lifecycle_locks',
  'repair_rows',
] as const satisfies readonly ManualQueueName[];

export type ManualQueueKey = ManualQueueName;
export type ManualQueueItem = ManualQueueItemDto;

export type ManualQueuePage = {
  items: ManualQueueItem[];
  page: number;
  totalPages: number;
  total: number;
  blocksPhase0: number;
  oldestBlockingAgeMs: number | null;
};

export const getManualQueue = async (queue: ManualQueueKey, page = 1): Promise<ManualQueuePage> => {
  const { data } = await api.get<ManualQueueListResponse>(apiPaths.superAdmin.manualQueue(queue), {
    params: { page, limit: 25 },
  });
  const extra = data.pagination.extra as Record<string, unknown>;
  return {
    items: data.data,
    page: data.pagination.page,
    totalPages: data.pagination.totalPages,
    total: typeof extra.total === 'number' ? extra.total : data.pagination.totalItems,
    blocksPhase0: typeof extra.blocks_phase0 === 'number' ? extra.blocks_phase0 : 0,
    oldestBlockingAgeMs: typeof extra.oldest_blocking_age_ms === 'number' ? extra.oldest_blocking_age_ms : null,
  };
};

export const submitManualQueueAction = async (
  input: {
    queue: ManualQueueKey;
    id: string;
  } & ManualQueueActionDto,
): Promise<ManualQueueItem> => {
  const { queue, id, version, action, reason } = input;
  const { data } = await api.post<ManualQueueItemResponse>(
    apiPaths.superAdmin.manualQueueAction(queue, id),
    { version, action, reason } satisfies ManualQueueActionDto,
    { skipAccountStateRetry: true },
  );
  return data.data;
};
